import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-task-move-to-next-workflow-state-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe],
})
export class TaskMoveToNextWorkflowStateApiManualV2Component extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Move Task to Next Workflow State",
            description: "Moves status from 'To Do' to 'Done' on a task with no reviewers. Moves the status from 'To do' to 'Ready for review' or from 'Ready for review' to 'Done' on a task where reviewers are set.",
            httpMethod: "POST",
            path: "/taskdata/v2/task/{guid}/workflow/advance",

            parameters: [
                {
                    name: "guid",
                    description: "guid of the task  to update",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "comment",
                    description: "comment to add to the task (only available when task is moved from 'Ready for review' to 'Done')",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "comment to add to the task",
                }
            ],

            responses: [
                {
                    code: "200",
                    description: "OK"
                }
            ]
        }
    }
}
